// Variant picker for the inkpunk aug shapes. The Vite plugin
// (config/vite/inkpunk-variants.js) generates INK_VARIANT_COUNT jittered
// silhouettes per shape, selected by [data-ink-seed="1..N"]; without the
// attribute an element gets the vendor's stock shape. These helpers hand out
// seeds so neighboring tears don't share a silhouette.

export const INK_VARIANT_COUNT = 8;

// Random start so each full page load deals a fresh sequence; increments per
// component instance, so siblings always differ.
let cursor = Math.floor(Math.random() * INK_VARIANT_COUNT);

export function nextInkSeed() {
  cursor = (cursor + 1) % INK_VARIANT_COUNT;
  return cursor + 1;
}

// Default corner treatments for cards. Mostly single quiet corners, a few
// two-corner combos; cycled so a grid of cards never repeats a placement
// back-to-back.
export const INK_CARD_AUGS = [
  'br-tear',
  'tl-tear',
  'tr-deckle',
  'bl-tear',
  'br-deckle tl-deckle',
  'tr-tear',
  'bl-splat',
  'tl-deckle br-tear',
];

let augCursor = Math.floor(Math.random() * INK_CARD_AUGS.length);

export function nextInkAug() {
  augCursor = (augCursor + 1) % INK_CARD_AUGS.length;
  return INK_CARD_AUGS[augCursor];
}

// Deterministic pick for list items: the same record keeps the same tear
// across re-renders and navigations (FNV-1a over the key).
export function inkSeedFor(key) {
  let h = 2166136261;
  for (const ch of String(key)) {
    h ^= ch.codePointAt(0);
    h = Math.imul(h, 16777619);
  }
  return ((h >>> 0) % INK_VARIANT_COUNT) + 1;
}
